import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Organisation, OrganisationDiscipline} from '../models/models.lib';
import {map, tap} from 'rxjs/operators';
import {ApiService} from '../api/api.service';

const { apiUrl } = environment;

export abstract class CasiOrganisationDisciplineService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(organisationId: number): void {
    this.fetch(organisationId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(organisationId: number): Observable<OrganisationDiscipline[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/organisation/discipline/all/${organisationId}`))
      .pipe(
        map((response: any, i) => {
          return <OrganisationDiscipline[]>response;
        }),
        map(r => r.map(x => OrganisationDiscipline.create(x))),
        tap(() => (this.loading = false))
      )
  }
}


@Injectable({
  providedIn: 'root'
})
export class OrganisationDisciplineService extends CasiOrganisationDisciplineService{
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(organisationId: number) {
    return this.apiService.getHttpCall(`organisation/discipline/all/${organisationId}`, 'get');
  }

  fetchAll() {
    return this.apiService.getHttpCall(`organisation/discipline`, 'fetchAll');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('organisation/discipline', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`organisation/discipline/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`organisation/discipline/${id}` , 'destroy');
  }
}
